import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingSpinner: React.FC = () => {
    return (
        <div className='spinner-full'>
            <Spinner color='primary' />
        </div>
    );
};

export default LoadingSpinner;
